import * as Request from './Request';

export const Api = {
  /**
   * 考试
   */
  // 获取考试列表
  getAllExamList (data) {
    return Request.post('/examresult/list', data);
  },
  // 获取考试类别
  getExamCategory () {
    return Request.get('/examresult/category/list');
  },
  // 新增考试
  addExam (data) {
    return Request.post('/examresult/import', data);
  },
  // 删除考试
  removeExam (data) {
    return Request.get(`/examresult/delete/${data}`);
  },
  // 发布考试
  releaseExam (data) {
    return Request.get(`/examresult/publish/${data}`);
  },
  // 取消发布考试
  examReleaseCancel (data) {
    return Request.get(`/examresult/un-publish/${data}`);
  },
  // 新增考试类型
  addExamCategory (data) {
    return Request.post('/examresult/category/insert', data);
  },
  // 修改考试类型
  editExamCategory (data) {
    return Request.post('/examresult/category/update', data);
  },
  // 修改考试类型
  deleteExamCategory (data) {
    return Request.get(`/examresult/category/delete/${data}`);
  },
  // 预览考试
  previewExam (data) {
    return Request.post('/examresult/preview', data);
  },
  // 获取查询字段
  getSearchKey (data) {
    return Request.get(`/examresult/check/search-fields/${data}`);
  },
  // 获取验证码
  getCaptcha () {
    return Request.get(`/captcha/get`);
  },
  // 获取查询结果
  getSearchDetail (data) {
    return Request.post(`/examresult/check/results`, data);
  },
};
